import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { track } from "@/lib/analytics";

const INTERESTS = [
  "Behavioral Health Consulting",
  "HR Consulting",
  "Catalyst Continuum",
  "Academy / Digital Resources",
  "Executive Coaching",
  "Other",
];

export default function ContactForm({ source = "main", defaultInterest }) {
  const [form, setForm] = useState({
    name: "",
    organization: "",
    email: "",
    interest: defaultInterest || INTERESTS[0],
    message: "",
  });
  const [state, setState] = useState({ loading: false, success: false, error: "" });

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, success: false, error: "" });
    try {
      await api.post("/leads", { ...form, source });
      track("generate_lead", { source, interest: form.interest });
      setState({ loading: false, success: true, error: "" });
      setForm({ name: "", organization: "", email: "", interest: defaultInterest || INTERESTS[0], message: "" });
    } catch (err) {
      setState({ loading: false, success: false, error: formatApiError(err) });
    }
  };

  return (
    <form onSubmit={submit} className="bg-white text-[var(--ink)] p-8" data-testid="contact-form">
      <div className="grid sm:grid-cols-2 gap-5 mb-5">
        <div className="field">
          <label className="field-label" htmlFor="cf-name">Name</label>
          <input id="cf-name" required type="text" placeholder="Your name"
            value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            data-testid="contact-name" />
        </div>
        <div className="field">
          <label className="field-label" htmlFor="cf-org">Organization</label>
          <input id="cf-org" type="text" placeholder="Organization name"
            value={form.organization} onChange={(e) => setForm({ ...form, organization: e.target.value })}
            data-testid="contact-org" />
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-5 mb-5">
        <div className="field">
          <label className="field-label" htmlFor="cf-email">Email</label>
          <input id="cf-email" required type="email" placeholder="you@company.com"
            value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            data-testid="contact-email" />
        </div>
        <div className="field">
          <label className="field-label" htmlFor="cf-interest">Area of Interest</label>
          <select id="cf-interest" value={form.interest}
            onChange={(e) => setForm({ ...form, interest: e.target.value })}
            data-testid="contact-interest">
            {INTERESTS.map((i) => <option key={i}>{i}</option>)}
          </select>
        </div>
      </div>
      <div className="field mb-5">
        <label className="field-label" htmlFor="cf-msg">How can we help?</label>
        <textarea id="cf-msg" rows={4} placeholder="Tell us about your goals or current challenge."
          value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })}
          data-testid="contact-message" />
      </div>
      <button type="submit" className="btn btn-navy w-full sm:w-auto" disabled={state.loading} data-testid="contact-submit">
        {state.loading ? "Sending…" : "Request Consultation"}
      </button>
      {state.success && (
        <p className="text-green-700 text-sm mt-4" data-testid="contact-success">
          Thank you — we've received your message and will be in touch within one business day.
        </p>
      )}
      {state.error && (
        <p className="text-red-700 text-sm mt-4" data-testid="contact-error">{state.error}</p>
      )}
    </form>
  );
}
